import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../translate';
import withCSRF from '../../../withCSRF';
import { compose } from '../../../../services/utilityFunctions';
import AuthOrganizationProp from '../../../../sections/profile/propTypes/authOrganizationProp';
import Request from '../../../../services/request';
import Notifications from '../../../../services/notifications';

function AuthOrganizationSelector({
  t,
  _csrf,
  authOrganizations,
  selectedOrganizationId,
}) {
  const onAuthOrganizationChanged = event => {
    const params = {
      organizationAuth: event.target.value,
      _csrf,
    };
    new Request(_csrf)
      .post('/signin/switch/organization', params)
      .done(() => {
        window.location.replace('/');
      })
      .fail(err => {
        console.log('$$$$ authOrganization.err: ', err);
        Notifications.showErrorFromRequest(err);
      });
  };

  return (
    <li className="m-nav__item">
      <div className="auth-organizations">
        <select
          id="organizationAuth"
          name="organizationAuth"
          className="form-control"
          style={{ height: '3rem', maxWidth: '170px' }}
          onChange={onAuthOrganizationChanged}
          defaultValue={selectedOrganizationId}
        >
          <optgroup label={t('your_organizations')}>
            {authOrganizations.map(org => (
              <option key={org.id} value={org.id}>
                {org.name}
              </option>
            ))}
          </optgroup>
        </select>
      </div>
    </li>
  );
}

AuthOrganizationSelector.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  authOrganizations: PropTypes.arrayOf(
    PropTypes.shape(AuthOrganizationProp.propType),
  ).isRequired,
  selectedOrganizationId: PropTypes.string.isRequired,
};

export default compose(translate, withCSRF)(AuthOrganizationSelector);
